import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { discounts as DISCOUNTS } from "rtr-constants";
import MembershipHelpers from "helpers/membership-helpers";
import { productPropType } from "components/propTypes";
import ProductPrice from "components/source/new_taxonomy/product-price";
import AtomRetailPrice from "../atoms/atom-retail-price";
import { isBulk, isClearance, isRental } from "helpers/price-helper";

export class PDPPrice extends Component {
  static propTypes = {
    annotationSuffix: PropTypes.string,
    isMembershipUpsellView: PropTypes.bool,
    isBuyNow: PropTypes.bool,
    isRentable: PropTypes.bool,
    isRetailOnly: PropTypes.bool,
    membershipPricing: PropTypes.array,
    product: productPropType.isRequired,
    rentalText: PropTypes.string,
    showPurchasePrice: PropTypes.bool,
    userData: PropTypes.object,
  };

  static defaultProps = {
    showPurchasePrice: true,
  };

  getPrice() {
    const { product: { price } = {} } = this.props;
    return price;
  }

  isBulk() {
    return isBulk(this.getPrice());
  }

  isClearance() {
    return isClearance(this.getPrice());
  }

  isUnlimitedLens() {
    return MembershipHelpers.isUnlimitedLens(this.props.userData) && !this.isClearance();
  }

  isRTRUpdateLens() {
    return MembershipHelpers.isRtrUpdateLens(this.props.userData) && !this.isClearance();
  }

  inPro15Experiment() {
    const { discounts } = this.getPrice() || {};
    if (!discounts || Object.keys(discounts).length === 0) return false;
    return discounts.find(({ id }) => id === DISCOUNTS.PRO_SUMMER);
  }

  isMembershipProduct() {
    const { isRentable, userData } = this.props;
    return MembershipHelpers.isSubscriptionLens(userData) && isRentable && !this.isClearance();
  }

  renderMembershipDiscountMessage() {
    const { isRentable, userData, isBuyNow } = this.props;

    if (
      !isBuyNow &&
      !this.props.isRetailOnly &&
      !MembershipHelpers.isSubscriptionLens(userData) &&
      MembershipHelpers.isSubscriptionMember(userData) &&
      isRentable
    ) {
      return <p className="mt-1 text-sm text-tealGreen italic">25% Membership Discount</p>;
    }
  }

  renderMembershipUpsellPrice() {
    const { isMembershipUpsellView } = this.props;

    if (isMembershipUpsellView || !this.isMembershipProduct()) {
      return this.renderProductPriceWrapped();
    }
  }

  renderProductPriceWrapped() {
    if (this.props.isRetailOnly || this.props.isBuyNow || this.isClearance()) return;

    const productPriceClassName = "pdp-price__price mr-2";
    const price = this.getPrice();

    if (!price) return;

    return (
      <div className={productPriceClassName}>
        <span className="mr-1">
          <ProductPrice
            annotationSuffix={this.props.annotationSuffix}
            membershipPricing={this.props.membershipPricing}
            price={price}
            showPurchasePrice={this.props.showPurchasePrice}
            adjustedMaximum={price.adjustedMaximum}
            minimum={price.minimum}
            discounts={price.discounts}
            maximum={price.maximum}
            minimumFormatted={price.minimumFormatted}
            maximumFormatted={price.maximumFormatted}
            adjusted={price.adjusted}
            base={price.base}
            isRental={isRental(price)}
            isClearance={isClearance(price)}
            isBulk={isBulk(price)}
            isUnlimitedLens={this.isUnlimitedLens()}
            isRTRUpdateLens={this.isRTRUpdateLens()}
            rentalText={this.props.rentalText}
          />
        </span>
      </div>
    );
  }

  renderPricing = () => {
    const {
      product: {
        designer: { id: designerId } = {},
        purchasePrice,
        retailPrice,
        retailPriceFormatted,
        price,
        purchasePriceDiscountFromRetailPrice,
      } = {},
    } = this.props;

    // if the flag is enabled and the item is bulk (i.e. masks or fashion solutions) then we don't need to show the
    // retail price, as the price will be displayed above the CTA
    if (isBulk(price)) return;

    if (isClearance(price)) {
      return (
        <AtomRetailPrice
          designerId={designerId}
          className="price-retail"
          isBulk={false}
          isClearance={isClearance(price)}
          product={this.props.product}
          purchasePrice={purchasePrice}
          purchasePriceDiscountFromRetailPrice={purchasePriceDiscountFromRetailPrice}
          retailPrice={retailPrice}
          retailPriceFormatted={retailPriceFormatted}
          showPurchasePrice={true}
          showPurchasePriceDiscount={true}
          showPurchasePriceTooltip={isClearance(price)}
          suppressRetailValueCopy={!isClearance(price)}
          hideRetailValue={!isClearance(price)}
        />
      );
    }

    return (
      <div>
        <div className="flex">
          {this.renderMembershipUpsellPrice()}
          <AtomRetailPrice
            designerId={designerId}
            className="flex items-center"
            tooltipAlign="left"
            priceClassName="universal-small--secondary"
            purchasePrice={purchasePrice}
            purchasePriceDiscountFromRetailPrice={purchasePriceDiscountFromRetailPrice}
            retailPrice={retailPrice}
            retailPriceFormatted={retailPriceFormatted}
            showPurchasePrice={false}
            showPurchasePriceDiscount={false}
            showPurchasePriceTooltip={true}
          />
        </div>
        {this.renderMembershipDiscountMessage()}
      </div>
    );
  };

  render() {
    let className = "pdp-price";
    if (this.props.isRetailOnly) {
      className += " pdp-price--retail-only";
    }

    return <div className={className}>{this.renderPricing()}</div>;
  }
}

const mapStateToProps = ({ isBuyNow, userData, product, membershipPricing }) => ({
  isBuyNow,
  userData,
  product,
  membershipPricing,
});

export default connect(mapStateToProps)(PDPPrice);
